import { atom } from "recoil";

const toState =atom({
    key: 'to',
    default: ''
})

export default toState